/**
 * Hook for branch-level access control.
 * Returns { isBranchAdmin, userBranch } from session storage.
 *
 * Usage in any component:
 *   const { isBranchAdmin, userBranch } = useBranchAccess();
 *   // If isBranchAdmin: lock branch dropdown, auto-select userBranch
 */
import { useMemo } from "react";

export default function useBranchAccess() {
  return useMemo(() => {
    try {
      const raw = JSON.parse(sessionStorage.getItem("user") || "{}");
      const userData = Array.isArray(raw) ? raw[0] : raw;
      return {
        isBranchAdmin: userData?.is_branch_admin || false,
        userBranch: userData?.branch || "",
      };
    } catch {
      return { isBranchAdmin: false, userBranch: "" };
    }
  }, []);
}
